export const ProgressBarCalculateCurrentProgress = (
    completed: number,
    total: number
): number => {
    const progress = Math.ceil((completed / total) * 100);
    return progress;
};
